import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_PROPOSITIONS = apiPromiseTypes('propositions', 'get');
